import React from "react";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { Margin } from "@mui/icons-material";

function GddCheckbox(props) {
    const { name, label, value, disabled = false, onChange } = props;

    const ValueConverter = (name, value) => ({
        target: {
            name,
            value,
        },
    });

    return (
        <FormControl>
            <FormControlLabel
                label={label}
                control={
                    <Checkbox
                        name={name}
                        color="primary"
                        checked={value}
                        disabled={disabled}
                        onChange={(e) =>
                            onChange(ValueConverter(name, e.target.checked))
                        }
                    />
                }
            />
        </FormControl>
    );
}

export default GddCheckbox;
